define('models/widgets/basket-count',['require','chaplin','models/base/widget'],function(require) {
    'use strict';

    var Chaplin = require('chaplin');
    var Widget = require('models/base/widget');

    var BasketCount = Widget.extend({
        action: 'widget.basketCount',
        defaults: {
            count: 0
        },
        initialize: function() {
            Widget.prototype.initialize.apply(this, arguments);
            this.on('change:count', this.publishStatus);
        },
        publishStatus: function(model, value) {
            Chaplin.mediator.pages.findWhere({ name: 'basket' }).set('status', value);
        }
    });

    return BasketCount;
});
